// Расшифровка ответа на запрос состояния принтера (Д9).
//
// `ESC !?` (0x1B 0x21 0x3F) → 1 байт битового поля, формат найден спайком T-035
// на реальном V3BT: `0x00` готов, `0x01` крышка открыта, `0x04` нет бумаги,
// флаги складываются (`0x05` = крышка открыта И нет бумаги разом).
//
// Владелец сузил объём (2026-09-05): статус — только РУЧНАЯ проверка с экрана
// настройки принтера, не часть цикла печати. Причина не техническая — лишний
// обмен на каждой этикетке того не стоит, а печать по-прежнему считается
// успешной по факту отправки байт (контракт `PrinterTransport.send` не менялся).

export type PrinterStatus = {
  readonly ready: boolean;
  readonly coverOpen: boolean;
  readonly paperOut: boolean;
};

const COVER_OPEN_BIT = 0x01;
const PAPER_OUT_BIT = 0x04;

export function decodePrinterStatus(byte: number): PrinterStatus {
  const coverOpen = (byte & COVER_OPEN_BIT) !== 0;
  const paperOut = (byte & PAPER_OUT_BIT) !== 0;
  return { ready: !coverOpen && !paperOut, coverOpen, paperOut };
}
